import request from '@/utils/request'
const BASE_URL = '/District'

//地区
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getMaxCode(Pid = 0) {
    return request({
      url: BASE_URL + '/GetMaxCode',
      method: 'get',
      params: { Pid }
    })
  }
}